import {Component, HostListener, Inject, OnInit} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import {NgbRatingConfig} from "@ng-bootstrap/ng-bootstrap";
import {PageTitleService} from "./commons/services/page-title/page-title.service";
import {UserSessionService} from "./auth/session/services/user-session/user-session.service";
import {PostBackgroundService} from "./commons/services/post-background/post-background.service";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

	public isScrolled = false;

	constructor(
		// injectable fields
		private translate: TranslateService,
		private ratingConfig: NgbRatingConfig,
		private router: Router,
		@Inject(PageTitleService) private pageTitleService: PageTitleService,
		@Inject(UserSessionService) private userSessionService: UserSessionService,
		@Inject(PostBackgroundService) private postBackgroundService: PostBackgroundService
	) {
		// initialize stuff
		this.initTranslations();
		this.initRatingConfiguration();
		this.initPostBackgrounds();
	}

	ngOnInit() {
		// set up stuff
		this.setupPageTitle();
	}

	/*Scroll event handler*/
	@HostListener("window:scroll", ["$event"])
	private onWindowScroll(): void {
		this.isScrolled = window.pageYOffset !== 0;
	}

	private initTranslations(): void {

		// translation service defaults
		this.translate.setDefaultLang("en");
		this.translate.use("en");

	}

	private initPostBackgrounds(): void {
		this.postBackgroundService.loadBackgrounds();
	}

	private initRatingConfiguration(): void {

		// bootstrap rating defaults
		this.ratingConfig.max = 5;
		this.ratingConfig.readonly = false;

	}

	private setupPageTitle(): void {

		// Reset page title
		this.pageTitleService.resetPageTitle();

	}
}
